import { useEffect, useState } from "react";
import { getWalletProjection } from "../services/walletApi";
import { WalletProjection } from "../types";

export function useWalletProjection(userId: string | null) {
  const [projection, setProjection] = useState<WalletProjection | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!userId) {
      setProjection(null);
      return;
    }

    const fetchProjection = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getWalletProjection(userId);
        setProjection(data);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Unknown error"));
      } finally {
        setLoading(false);
      }
    };

    // Initial fetch
    fetchProjection();

    // Poll every 30 seconds
    const interval = setInterval(fetchProjection, 30000);
    return () => clearInterval(interval);
  }, [userId]);

  const refresh = async () => {
    if (!userId) return;
    setLoading(true);
    try {
      const data = await getWalletProjection(userId);
      setProjection(data);
    } catch (err) {
      setError(err instanceof Error ? err : new Error("Unknown error"));
    } finally {
      setLoading(false);
    }
  };

  return { projection, loading, error, refresh };
}
